import { cn } from "@/web/lib/styling";
import { BrowseCard } from "@/web/routes/browse/-components/cards/BrowseCard";
import { DropdownLockProvider } from "@/web/routes/browse/-components/cards/BusinessCard";
import { GenericCardLoader } from "@/web/routes/browse/-components/GenericCardLoader";
import { NoMatchesCta } from "@/web/routes/browse/-components/NoMatchesCta";
import type { useCampaignBrowser } from "@/web/routes/browse/-components/useBrowse";

type UseCampaignBrowserReturn = ReturnType<typeof useCampaignBrowser>;

export function CampaignResultsContainer({
  useCampaignBrowserRet,
  className,
}: {
  useCampaignBrowserRet: UseCampaignBrowserReturn;
  className?: string;
}) {
  const { results, isPending, isFetching, hasNextPage, getResultKey } = useCampaignBrowserRet;

  if (isPending) {
    return (
      <div
        className={cn(
          "grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5",
          className,
        )}
      >
        {Array.from({ length: 4 }).map((_, i) => (
          // oxlint-disable-next-line react/no-array-index-key skeleton placeholders
          <GenericCardLoader key={i} />
        ))}
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className={cn("grid grid-cols-1 gap-4 md:flex md:flex-wrap", className)}>
        <NoMatchesCta />
      </div>
    );
  }

  return (
    <DropdownLockProvider>
      <div
        className={cn(
          "grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5",
          className,
        )}
      >
        {results.map((result) => (
          <BrowseCard key={getResultKey(result)} result={result} />
        ))}
        {!isPending && hasNextPage && isFetching && <GenericCardLoader />}
      </div>
      {!hasNextPage && results.length > 10 && (
        <div className="pt-4 text-center text-sm text-muted-foreground">No more results</div>
      )}
    </DropdownLockProvider>
  );
}
